module.exports = __webpack_public_path__ + "img/9788958287988.8d861a16.jpg";